import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";
import { AuthCard, PasswordField, AuthError } from "../components/AuthUI";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Las dos contraseñas no coinciden."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña nueva guardada. Ya podés ingresar.");
      navigate("/estudio/login", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Nueva contraseña" subtitle="Elegí una contraseña de al menos 8 caracteres." testId="reset-page">
      {!token ? (
        <AuthError message="El enlace está incompleto. Pedí uno nuevo desde «Olvidé mi contraseña»." />
      ) : (
        <form onSubmit={submit}>
          <AuthError message={error} />
          <PasswordField label="Contraseña nueva" id="reset-pass" value={password} onChange={(e) => setPassword(e.target.value)} testId="reset-password-input" autoComplete="new-password" />
          <PasswordField label="Repetir contraseña nueva" id="reset-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} testId="reset-confirm-input" autoComplete="new-password" />
          <button type="submit" disabled={busy} className="pill pill-primary auth-btn w-full" data-testid="reset-submit-button">
            <KeyRound size={22} /> {busy ? "Guardando…" : "Guardar contraseña"}
          </button>
        </form>
      )}
      <div className="text-center mt-8">
        <Link to="/estudio/olvide" className="text-lg font-semibold text-[#A36A00] underline underline-offset-4" data-testid="reset-request-new-link">
          Pedir un enlace nuevo
        </Link>
      </div>
    </AuthCard>
  );
}
